import { render } from "./ListaClienti.vue?vue&type=template&id=e69d6870&ts=true"
import script from "./ListaClienti.vue?vue&type=script&lang=ts"
export * from "./ListaClienti.vue?vue&type=script&lang=ts"

import "./ListaClienti.vue?vue&type=style&index=0&id=e69d6870&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__